import {
  makeStyles, Button,
} from '@material-ui/core';

import { SHARE_ACCESS_TYPE } from '../config/constant';
import { useTranslation } from '../LocalizationProvider';
import { checkShareUrlType } from '../helpers/misc';

const useStyles = makeStyles((theme) => ({
  navButton: {
    border: '2px solid rgba(76, 175, 80, 1)',
  }
}));

const TemporaryLogoutButton = (props) => {
  const { currentLink = {} } = props

  const t = useTranslation();
  const classes = useStyles();

  const onClickLogout = () => {
    const session = window.localStorage.getItem('trip_session')
    if (session) {
      if (window.confirm('Are you sure you want to logout?')) {
        window.localStorage.removeItem('trip_session')
        window.location.reload(true)
      }
    }
  }

  return (
    <>
      {
        (checkShareUrlType(currentLink.shareUrl) === SHARE_ACCESS_TYPE.RESERVATION_ID) ? (
          <Button color="secondary" className={classes.navButton} style={{ minWidth: '90px', marginTop: '0px', marginBottom: '0px' }}
            onClick={() => onClickLogout()}>
            {t('Logout')}
          </Button>
        ) : (
          <div></div>
        )
      }
    </>
  )
}
export default TemporaryLogoutButton;
